import { HttpClient } from '@/core/utils/httpClient'

import {
  GetAllSettingsRequest,
  GetAllSettingsResponse,
  GetDriversPercentsRequest,
  GetDriversPercentsResponse,
  GetMileageServiceResponse,
  RegionParkUseOwnSettingsRequest,
  UpdateCommonSettingsRequest,
  UpdateCommonSettingsResponse,
  UpdateDriversPercentsRequest,
  UpdateDriversPercentsResponse,
  UpdateFinesRequest,
  UpdateFinesResponse,
  UpdateMileageServiceRequest,
  UpdateMileageServiceResponse,
  UpdateRentSettingsRequest,
  UpdateRentSettingsResponse,
  UpdateRetentionBordersRequest,
  UpdateRetentionBordersResponse,
  UpdateTimeZoneRequest,
  UpdateTimeZoneResponse,
} from 'rikroot-types/parksmanagement/settings.pb'

export class SettingsRepository extends HttpClient {
  async getAllSettings(params: GetAllSettingsRequest): Promise<GetAllSettingsResponse> {
    return await this.get('/park_management/settings', { params })
  }

  async getDriversPercents(params: GetDriversPercentsRequest): Promise<GetDriversPercentsResponse> {
    return await this.get('/park_management/settings/drivers_percents', { params })
  }

  async getServiceMileage(): Promise<GetMileageServiceResponse> {
    return await this.get('/park_management/settings/mileage_services')
  }

  async updateServiceMileage(
    data: UpdateMileageServiceRequest,
  ): Promise<UpdateMileageServiceResponse> {
    return await this.put('/park_management/settings/mileage_services', data)
  }

  async updateSettingsRent(data: UpdateRentSettingsRequest): Promise<UpdateRentSettingsResponse> {
    return await this.put('/park_management/settings/rent_settings', data)
  }

  async updateDriversPercents(
    data: UpdateDriversPercentsRequest,
  ): Promise<UpdateDriversPercentsResponse> {
    return await this.put('/park_management/settings/drivers_percents', data)
  }

  async updateCommonSettings(
    data: UpdateCommonSettingsRequest,
  ): Promise<UpdateCommonSettingsResponse> {
    return await this.put('/park_management/settings/common_settings', data)
  }

  async updateFines(data: UpdateFinesRequest): Promise<UpdateFinesResponse> {
    return await this.put('/park_management/settings/fines', data)
  }

  async regionParkUseOwnSettings(
    params: RegionParkUseOwnSettingsRequest,
  ): Promise<GetAllSettingsResponse> {
    return await this.post('/park_management/settings/region_park_use_own_settings', null, {
      params,
    })
  }

  async updateRetentionBorders(
    data: UpdateRetentionBordersRequest,
  ): Promise<UpdateRetentionBordersResponse> {
    return await this.put('/park_management/settings/retention_borders', data)
  }

  async updateTimeZone(data: UpdateTimeZoneRequest): Promise<UpdateTimeZoneResponse> {
    return await this.put('/park_management/settings/time_zone', data)
  }
}
